import AmountSelector from 'components/AmountSelector/AmountSelector.vue'
import { computed, ref } from 'vue'
import { useStore } from 'vuex'

export default {
    name: 'StafetRoundCounter',
    components: { AmountSelector },
    props: {
        rute: {
            type: Object,
            required: true
        },
        deltagerId: {
            type: String,
            required: false
        },
        maxRegistrationCount: {
            type: Number,
            required: false,
            default: 100
        }
    },
    setup(props) {
        const store = useStore()

        const amount = computed(() => {
            const { deltagerId, rute } = props

            const count = deltagerId 
                ? store.getters['stafetRoundCounter/getDeltagerRuteAmount']({
                    deltagerId,
                    ruteId: rute.id
                })
                : store.state.stafetRoundCounter.ruteUpdates[rute.id] ?? 0

            return {
                count,
                key: amountKey.value
            }
        })
        const amountKey = ref(0)

        const shouldDisableApplyButton = computed(() => store.getters['stafetRoundCounter/shouldDisableApplyButton']({
                deltagerId: props.deltagerId, 
                ruteId: props.rute.id 
            })
        )

        const handleSetRoundCount = e => {
            let intValue = parseInt(e.target.value)
            if (isNaN(intValue)) {
                intValue = 0
            }
            else if (intValue > props.maxRegistrationCount) {
                intValue = props.maxRegistrationCount
            }

            if (props.deltagerId) {
                store.commit("stafetRoundCounter/set_deltager_counter", { 
                    deltagerId: props.deltagerId, 
                    ruteId: props.rute.id,
                    count: intValue
                })
            } else {
                store.commit("stafetRoundCounter/set_rute_counter", {
                    ruteId: props.rute.id,
                    count: intValue
                })
            }

            amountKey.value++
        }
        
        const handleAddOneRound = function () {

            if (amount.value.count >= props.maxRegistrationCount) {
                return
            }

            if (props.deltagerId) {
                store.commit("stafetRoundCounter/increment_deltager_counter", { 
                    deltagerId: props.deltagerId, 
                    ruteId: props.rute.id
                })
            } else {
                store.commit("stafetRoundCounter/increment_rute_counter", props.rute.id)
            }
            
        }

        const handleRemoveOneRound = function () {
            if (props.deltagerId) {
                store.commit("stafetRoundCounter/decrement_deltager_counter", { 
                    deltagerId: props.deltagerId, 
                    ruteId: props.rute.id
                })
            } else {
                store.commit("stafetRoundCounter/decrement_rute_counter", props.rute.id)
            }
        }

        const handleSubmit = function () {
            store.dispatch("stafetRoundCounter/stafetRoundCounterSubmit", { 
                deltagerId: props.deltagerId, 
                ruteId: props.rute.id
            })
        }

        return {
            amount,
            shouldDisableApplyButton,
            handleSetRoundCount,
            handleAddOneRound,
            handleRemoveOneRound,
            handleSubmit,
            getLabel: (labelKey) =>
                store.getters['labels/getLabel']({
                    labelCollection: 'roundCounter',
                    labelKey
                })
        }
    }
}
